import format from "./Util_methods/format";

export const baseUrl: string = "api/";
export const ppLogoStyle: any = { width: "4.5em" }; //inline to override semantic list:img css

let startDate: any = new Date(2020, 2, 17);
//startDate.setDate(new Date(2020, 3, 20).getDate); //startDate.getDate() - 6
let end: any = new Date(2020, 2, 23);
let jiraEnd = new Date();
export const defaultDate: any = {
  start: startDate,
  end: end,
  jiraEnd: jiraEnd,
};

export const appName: string = "Service View";
export const defaultDateStrings: any = {
  start: format.date(startDate),
  end: format.date(end),
  jiraEnd: format.date(jiraEnd),
};

let maxDate: any = new Date();
maxDate.setHours(24, 0, 0, 0);
export const max: any = maxDate;
export const min: any = new Date(2012, 1, 1);

export const gridIntervalsArray: { timeUnit: string; count: number }[] = [
  { timeUnit: "millisecond", count: 1 },
  { timeUnit: "millisecond", count: 5 },
  { timeUnit: "millisecond", count: 10 },
  { timeUnit: "millisecond", count: 100 },
  { timeUnit: "second", count: 1 },
  { timeUnit: "second", count: 5 },
  { timeUnit: "second", count: 10 },
  { timeUnit: "second", count: 30 },
  { timeUnit: "minute", count: 1 },
  { timeUnit: "minute", count: 5 },
  { timeUnit: "minute", count: 10 },
  { timeUnit: "minute", count: 15 },
  { timeUnit: "minute", count: 20 },
  { timeUnit: "minute", count: 25 },
  { timeUnit: "minute", count: 30 },
  { timeUnit: "hour", count: 1 },
  { timeUnit: "hour", count: 4 },
  { timeUnit: "hour", count: 6 },
  { timeUnit: "hour", count: 8 },
  { timeUnit: "hour", count: 10 },
  { timeUnit: "hour", count: 12 },
  { timeUnit: "hour", count: 14 },
  { timeUnit: "hour", count: 16 },
  { timeUnit: "hour", count: 18 },
  { timeUnit: "hour", count: 20 },
  { timeUnit: "hour", count: 22 },
  { timeUnit: "hour", count: 24 },
  { timeUnit: "day", count: 1 },
  { timeUnit: "day", count: 2 },
  { timeUnit: "day", count: 3 },
  { timeUnit: "day", count: 4 },
  { timeUnit: "day", count: 5 },
  { timeUnit: "week", count: 1 },
  { timeUnit: "month", count: 1 },
];

export const groupIntervalsArray: { timeUnit: string; count: number }[] = [
  { timeUnit: "millisecond", count: 1 },
  { timeUnit: "millisecond", count: 10 },
  { timeUnit: "millisecond", count: 100 },
  { timeUnit: "second", count: 1 },
  { timeUnit: "second", count: 10 },
  { timeUnit: "second", count: 30 },
  { timeUnit: "minute", count: 1 },
];
